// removed by extract-text-webpack-plugin
module.exports = {"desktopColumns":"_1IPby2ZrecEFMnuvPEsGK_","desktopFlexWrap":"_20kqlvSi51cJhbY6jmAhYX"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 28
// module chunks = 0